'use strict';

import { view } from '@/functions';

export default [
    {
        path: '/ai-knowledge',
        name: 'ai-knowledge',
        meta: {
            title: 'AI knowledge',
            scopes: ['read_ai_conversations'],
        },
        component: () => view('ai-knowledge/index'),
    },
];
